<!-- views/admin/children/Introduction.vue -->
<template>
  <div class="introduction-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>大赛简介配置</h1>
      <div class="header-actions">
        <button class="btn preview-btn" @click="previewSection">预览板块</button>
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>

    <!-- 配置编辑区域 -->
    <div class="config-editor">
      <!-- 板块基础信息 -->
      <div class="config-section">
        <div class="section-header">
          <h2>板块基础信息</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>板块标题</label>
            <input type="text" v-model="sectionData.title" placeholder="请输入板块标题">
          </div>
          <div class="form-group">
            <label>板块描述</label>
            <textarea v-model="sectionData.desc" placeholder="请输入板块描述"></textarea>
          </div>

          <!-- 主办方视频上传 -->
          <div class="form-group">
            <label>介绍视频</label>
            <div class="media-upload-container">
              <!-- 已上传的视频 -->
              <div v-if="sectionData.video" class="video-preview">
                <video :src="sectionData.video" controls class="preview-video"></video>
                <button class="remove-video-btn" @click="removeHostVideo">移除视频</button>
              </div>
              <div v-else class="upload-placeholder video-upload" @click="$refs.hostVideoUpload.click()">
                <span v-if="!isUploading">上传视频</span>
                <span v-else>上传中...</span>
              </div>
              <input
                  type="file"
                  ref="hostVideoUpload"
                  @change="uploadHostVideo"
                  accept="video/*"
                  hidden
              />
            </div>
          </div>

        </div>
      </div>

      <!-- 内容模块配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>内容模块配置</h2>
        </div>
        <div class="section-content">
          <div v-for="(module, index) in sectionData.data.modules" :key="index" class="module-item">
            <div class="module-header">
              <h3>模块 {{ index + 1 }} ({{ getModuleTypeName(module.type) }})</h3>
              <button class="remove-btn" @click="removeModule(index)">删除</button>
            </div>
            <div class="form-group">
              <label>模块类型</label>
              <select v-model="module.type">
                <option value="theme">大赛主题</option>
                <option value="advantage">参赛优势</option>
                <option value="welfare">参赛福利</option>
              </select>
            </div>
            <div class="form-group">
              <label>模块标题</label>
              <input type="text" v-model="module.title" placeholder="请输入模块标题">
            </div>
            <div class="form-group">
              <label>模块内容</label>
              <textarea v-model="module.content" placeholder="请输入模块内容"></textarea>
            </div>
          </div>
<!--        <button class="add-module-btn" @click="addModule">添加模块</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getBanner, updateBannerApi ,uploadFileApi} from '@/api/website'

// 板块数据
const sectionData = ref({
  id: "intro",
  title: "",
  desc: "",
  component: "IntroCard",
  video: "",
  data: {
    modules: []
  }
})

const isSaving = ref(false)
const allConfig = ref({}) // 保存完整的配置数据
const isUploading = ref(false)  // 添加这一行

// 加载配置
const loadConfig = async () => {
  try {
    const response = await getBanner({"adminId":1})
    if (response.data) {
      allConfig.value = response.data.data

      // 查找intro板块数据
      const introSection = allConfig.value.data.sections.find(section => section.id === "intro")
      if (introSection) {
        sectionData.value = {
          ...sectionData.value,
          ...introSection
        }
      }
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}

// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true

    // 更新完整配置中的intro板块数据
    const sectionIndex = allConfig.value.data.sections.findIndex(section => section.id === "intro")
    if (sectionIndex !== -1) {
      allConfig.value.data.sections[sectionIndex] = {...sectionData.value}
    }

    // 查找并更新导航栏中指向#intro的链接标题
    const navSection = allConfig.value.data.sections.find(section => section.id === "nav")
    if (navSection) {
      const introNavItem = navSection.data.find(item => item.link === "#intro")
      if (introNavItem) {
        introNavItem.label = sectionData.value.title
      }
    }

    await updateBannerApi(allConfig.value)
    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}
// 预览板块
const previewSection = () => {
  alert('预览功能待实现')
}
//删除主办方视频
const removeHostVideo = (index) => {
  sectionData.value.video =  '';
  console.log('sectionData.video:',sectionData.value.video)

};
// 上传主办方视频
const uploadHostVideo = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;

  try {
    isUploading.value = true;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('multipartFile', file);

      const response = await uploadFileApi(formData);
      if (response.data && response.data.data) {
        sectionData.value.video =  response.data.data;
      }
    }
  } catch (error) {
    console.error('上传图片失败:', error);
    alert('上传失败，请重试');
  } finally {
    isUploading.value = false; // 无论成功或失败都重置加载状态
  }
};
// 添加模块
const addModule = () => {
  sectionData.value.data.modules.push({
    type: "theme",
    title: "",
    content: ""
  })
}

// 删除模块
const removeModule = (index) => {
  if (confirm('确定要删除这个模块吗？')) {
    sectionData.value.data.modules.splice(index, 1)
  }
}

// 获取模块类型名称
const getModuleTypeName = (type) => {
  const types = {
    theme: '大赛主题',
    advantage: '参赛优势',
    welfare: '参赛福利'
  }
  return types[type] || type
}

// 初始化加载配置
onMounted(() => {
  loadConfig()
})
</script>

<style scoped lang="scss">
.introduction-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;

  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .preview-btn {
    background-color: #1890ff;
    color: white;

    &:hover:not(:disabled) {
      background-color: #40a9ff;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"],
  input[type="color"],
  select,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.module-item {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
  }

  .remove-btn {
    padding: 4px 12px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background-color: #d9363e;
    }
  }
}

.add-module-btn {
  width: 100%;
  padding: 12px;
  border: 2px dashed #ddd;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
    background-color: rgba(24, 144, 255, 0.05);
  }
}
.media-upload-container {
  width: 100%;
}

.video-preview {
  .preview-video {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .remove-video-btn {
    margin-top: 10px;
    padding: 4px 12px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #d9363e;
    }
  }
}
.upload-placeholder {
  width: 200px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ddd;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
}

.upload-placeholder {
  width: 100px;
  height: 100px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 24px;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }

  &.video-upload {
    width: 200px;
    font-size: 14px;
  }
}
</style>
